export default __webpack_public_path__ + "b6a67607b922ea6ae8f4509ec6041a9a.ttf";